"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentItemPerformanceSerializer = void 0;
var student_item_performance_model_1 = require("../../models/student-item-performance.model");
var StudentItemPerformanceSerializer = /** @class */ (function () {
    function StudentItemPerformanceSerializer() {
    }
    StudentItemPerformanceSerializer.prototype.serialize = function (_a) {
        var itemExternalId = _a.itemExternalId, maxScore = _a.maxScore, score = _a.score, attemptId = _a.attemptId, assigneeId = _a.assigneeId, externalQuestionId = _a.externalQuestionId;
        return new student_item_performance_model_1.StudentItemPerformance({
            itemExternalId: itemExternalId,
            maxScore: maxScore,
            score: score,
            attemptId: attemptId,
            assigneeId: assigneeId,
            externalQuestionId: externalQuestionId,
        });
    };
    return StudentItemPerformanceSerializer;
}());
exports.StudentItemPerformanceSerializer = StudentItemPerformanceSerializer;
